/**
 * Legacy Decimal/SSE `market_update` shapes:
 * - Live SSE / client store (flat): `{ markets, event_status, betting_status, … }`
 * - HTTP initial-state / subscribe dump (wrapped): `{ msg_type, feed_id, market_update: { markets, … } }`
 *
 * Cards and DecimalSocketContext read `streamData.market_update.markets`. Without unwrapping the
 * nested envelope, lobby poll snapshots look empty → SUS even when Match Winner is priced.
 */
export function unwrapStreamMarketUpdate<T extends Record<string, unknown> | null | undefined>(
  marketUpdate: T,
): T {
  if (!marketUpdate || typeof marketUpdate !== "object" || Array.isArray(marketUpdate)) {
    return marketUpdate;
  }
  const mu = marketUpdate as Record<string, unknown>;
  if (Array.isArray(mu.markets)) {
    return marketUpdate;
  }
  const inner = mu.market_update;
  if (!inner || typeof inner !== "object" || Array.isArray(inner)) {
    return marketUpdate;
  }
  const nested = inner as Record<string, unknown>;
  if (!Array.isArray(nested.markets)) {
    return marketUpdate;
  }
  const out: Record<string, unknown> = { ...nested };
  if (out.market_snapshot == null && mu.market_snapshot != null) {
    out.market_snapshot = mu.market_snapshot;
  }
  if (out.settled_market_keys == null && Array.isArray(mu.settled_market_keys)) {
    out.settled_market_keys = mu.settled_market_keys;
  }
  return out as T;
}
